import { render, staticRenderFns } from "./oa-form.vue?vue&type=template&id=01a9a7f8&scoped=true"
import script from "./oa-form.vue?vue&type=script&lang=js"
export * from "./oa-form.vue?vue&type=script&lang=js"
import style0 from "./oa-form.vue?vue&type=style&index=0&id=01a9a7f8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a9a7f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a9a7f8')) {
      api.createRecord('01a9a7f8', component.options)
    } else {
      api.reload('01a9a7f8', component.options)
    }
    module.hot.accept("./oa-form.vue?vue&type=template&id=01a9a7f8&scoped=true", function () {
      api.rerender('01a9a7f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-common/oa-form.vue"
export default component.exports